/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-import': {
    width: 3,
    height: 7,
    viewBox: '0 0 3 7',
    data: '<defs><path pid="0" d="M.62 5.48V.88L.05.85V0h2.42v.81l-.33.03c-.193.02-.29.127-.29.32v4.61l.57.03v.85H0v-.81l.33-.03a.396.396 0 0 0 .22-.085c.047-.043.07-.125.07-.245z" id="svgicon-icon-status-import-a"/></defs><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon-icon-status-import-a"/>'
  }
})
